import * as React from "react";

function SvgSunglasses(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g clipPath="url(#sunglasses_svg__clip0)">
        <path d="M19.664 8.567L13.495 4.34a1.366 1.366 0 00-1.412-.082c-.45.238-.73.702-.73 1.211v.709h1.166v-.709c0-.106.068-.157.108-.178a.195.195 0 01.208.012l4.942 3.386-6.425.668v.475a2.529 2.529 0 00-2.705-.003v-.472L2.224 8.69l4.941-3.386a.195.195 0 01.209-.012c.04.02.108.072.108.178v.709h1.167v-.709c0-.51-.28-.973-.731-1.21a1.366 1.366 0 00-1.412.081L.268 8.614l.318.464-.318-.464L0 8.798v2.778c0 1.162.454 2.251 1.278 3.07A4.293 4.293 0 004.323 15.9h.033c2.258-.017 4.114-1.802 4.28-4.044.06-.701.658-1.25 1.364-1.25.71 0 1.305.548 1.364 1.252.167 2.24 2.022 4.025 4.28 4.042h.033c1.149 0 2.229-.445 3.045-1.255A4.294 4.294 0 0020 11.576V8.798l-.336-.23z" />
      </g>
    </svg>
  );
}

export default SvgSunglasses;
